export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'workflow.tableColumns.workflowName',
        accessor: 'name',
      },
      {
        Header: 'scheduleFrequency.tableColumns.activity_type_name',
        accessor: 'activity_name',
      },
      // {
      //   Header: 'Status',
      //   accessor: 'status',
      // },
      {
        Header: 'workflow.tableColumns.status',
        accessor: 'publish_status',
      },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }